import { FC } from "react";
import { endOfDay, startOfDay, startOfMonth, startOfQuarter, startOfWeek } from "date-fns";

import { Button } from "../button";
import { ButtonColor } from "../button/types";
import { DateTimePicker } from "../dateTimePicker";
import { DateTimePickerProps } from "../dateTimePicker/types";
import style from "./style.module.scss";

interface Props extends DateTimePickerProps {
	id: string;
	label: string;
	value: [Date | undefined, Date | undefined];
	setValue: ([start, end]: [Date | undefined, Date | undefined]) => void;

	/**
	 * Show the quick selection options to select range
	 * Options are:
	 *  - Day
	 *  - Week
	 *  - Month
	 *  - Quarter
	 *  - All
	 */
	quickRange?: boolean;
}

export const DateTimeRangePicker: FC<Props> = (props) => {
	const { setValue, id, label, value, quickRange, ...rest } = props;

	function dayClicked() {
		setValue([startOfDay(new Date()), endOfDay(new Date())]);
	}

	function weekClicked() {
		setValue([startOfWeek(new Date()), endOfDay(new Date())]);
	}

	function monthClicked() {
		setValue([startOfMonth(new Date()), endOfDay(new Date())]);
	}

	function quarterClicked() {
		setValue([startOfQuarter(new Date()), endOfDay(new Date())]);
	}

	function allClicked() {
		setValue([undefined, undefined]);
	}

	return (
		<div>
			<div className={style.root}>
				<DateTimePicker
					{...rest}
					id={`${id}-start`}
					label={label}
					value={value[0]}
					changeHandler={(v) => setValue([v, value[1]])}
				/>
				<DateTimePicker
					{...rest}
					id={`${id}-end`}
					label=""
					value={value[1]}
					changeHandler={(v) => setValue([value[0], v])}
					className={style.input}
				/>
			</div>
			{quickRange ? (
				<div className={style.buttons}>
					<Button onClick={dayClicked} color={ButtonColor.Green}>
						Day
					</Button>
					<Button onClick={weekClicked} color={ButtonColor.Green}>
						Week
					</Button>
					<Button onClick={monthClicked} color={ButtonColor.Green}>
						Month
					</Button>
					<Button onClick={quarterClicked} color={ButtonColor.Green}>
						Quarter
					</Button>
					<Button onClick={allClicked} color={ButtonColor.Green}>
						All
					</Button>
				</div>
			) : null}
		</div>
	);
};
